<template>
  <div id="app">
    <app-header></app-header>
    <router-view/>
    <app-footer></app-footer>
  </div>
</template>

<script>

  require('waypoints/lib/noframework.waypoints.js')

  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'
  

  import {mapActions} from 'vuex';

  export default {
    name: 'App',
    mounted(){
      this.initApp();
    },
    components : {
      'app-header' : header,
      'app-footer' : footer,
    },
    methods : {
      ...mapActions(['initApp'])
    }
  }
</script>

<style  lang="scss">
@import '@/assets/css/colors.scss';
@import './assets/css/style.scss';
@import './assets/css/slick.css';
@import './assets/css/responsive.scss';
@import url('https://fonts.googleapis.com/css2?family=DM+Serif+Text&family=Muli:wght@400;600;900&display=swap');
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
@import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);
</style>



// WEBPACK FOOTER //
// src/App.vue